export class ClienteContador {
  clienteContadorId: number;
  razaoSocial: string;
  nomeFantasia: string;
  cnpj: string;
  telefone: string;
  municipioId: number;
  ufId: number;
  paisId: number;
  clienteId: number;
}
